module.exports = __webpack_public_path__ + "img/img.a662faea.png";